<template>
  <div>
    <!-- 自定义导航 -->
    <Nav></Nav>
    <!-- 自定义导航-->
    <div class="register-action">
      <div class="register-title">注册账号</div>
      <div class="input-wrap">
        <img src="../../../assets/img/login_btn_user.png" alt="">
        <input type="text" placeholder="请输入用户名" v-model="nickname" onkeyup="this.value=this.value.replace(/[, ]/g,'')">
        <img v-show="nickname" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('nickname')">
      </div>
      <div class="input-wrap">
        <img src="../../../assets/img/login_btn_phone.png" alt="">
        <input type="text" placeholder="请输入手机号" v-model="phone" @input="checkPhone">
        <img v-show="phone" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('phone')">
      </div>
      <div class="code-wrap">
        <div class="text-wrap">
          <img src="../../../assets/img/login_btn_validation.png" alt="">
          <input type="text"  v-model="code" placeholder="请输入验证码">
        </div>
        <div v-show="!showCountDown" class="code-btn" @click="sendSms">
          获取验证码
        </div>
        <div v-show="showCountDown" class="clock-btn">
          重新发送({{countDown}})s
        </div>
      </div>
      <div class="input-wrap">
        <img src="../../../assets/img/login_btn_password.png" alt="">
        <input type="password" ref="password" placeholder="请输入密码 (长度不少于6-30位)" v-model="password">
        <img v-show="password" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('password')">
        <img v-show="!type_password" src="../../../assets/img/h5/official/register_icon_close.png" alt="" @click="visiblePass('password')">
        <img v-show="type_password" src="../../../assets/img/h5/official/register_icon_open.png" alt="" @click="visiblePass('password')">
      </div>
      <div class="input-wrap">
        <img src="../../../assets/img/login_btn_password.png" alt="">
        <input type="password" ref="repassword" placeholder="确认登录密码" v-model="repassword">
        <img v-show="repassword" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('repassword')">
        <img v-show="!type_repassword" src="../../../assets/img/h5/official/register_icon_close.png" alt="" @click="visiblePass('repassword')">
        <img v-show="type_repassword" src="../../../assets/img/h5/official/register_icon_open.png" alt="" @click="visiblePass('repassword')">
      </div>
      <div class="go-register" @click="register">注册</div>
    </div>
  </div>
</template>
<script>
  import Nav from '@/components/h5/Nav.vue'
  import { registerSms,register } from '@/api/user'
  export default {
      name: 'Home',
      components: {
        Nav
      },
      data() {
        return {
          nickname: '',  //用户名
          password: '',  //密码
          repassword: '', //确认密码
          phone: '',  //手机号
          code: '',  //验证码
          invite_code: '',//邀请人UUID
          showCountDown:false,//显示倒计时
          countDown: 60,  //倒计时
          loading:false,
          tip:'',
          type_password: false, //密码输入框input是否可见
          type_repassword: false,//确认密码输入框input是否可见
        }
      },
      created() {
        if(this.$route.query.invite_code){
          this.invite_code = this.$route.query.invite_code
        }else{
          this.invite_code = localStorage.getItem('inviteCode')
        }
      },
      methods: {
        sendSms(){
          if(!this.validateNickname() || !this.validatePhone()){
            this.$toast.fail(this.tip)
            return
          }
          this.showCountDown = true
          registerSms({
            nickname:this.nickname,
            mobile: this.phone,
          }).then(response => {
            this.$toast.success(response.message)
            this.timer = setInterval(()=>{
              this.countDown--
              if(this.countDown === 0){
                this.showCountDown = false
                this.countDown = 60;
                clearInterval(this.timer)
              }
            },1000)
          }).catch(error => {
            console.log(error)
            this.showCountDown = false
          })
        },
        register(){
          if(this.loading){
            return
          }
          if(!this.validateNickname() || !this.validatePhone() || !this.validateCode() || !this.validatePassword()){
            this.$toast.fail(this.tip)
            return
          }
          this.loading = true
          register({
            nickname:this.nickname,
            password: this.password,
            repassword:this.repassword,
            mobile: this.phone,
            code: this.code,
            invite_code: this.invite_code
          }).then(response => {
            this.loading = false
            this.$dialog.alert({
              title: '提示',
              message: '注册成功！',
              theme: 'round-button',
            }).then(() => {
              // on close
              this.$router.push('/h5/home')
            })
          }).catch(error => {
            console.log(error)
            this.loading = false
          })
        },
        //清除文本框
        clear(val) {
          this[val] = ''
        },
        //监听手机
        checkPhone() {
          this.phone = this.phone.replace(/[^\d]/g, '')
        },
        // 验证手机
        validatePhone() {
          if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone))) {
            this.tip = '手机号格式不正确'
            return false;
          }
          return true;
        },
        //验证昵称
        validateNickname() {
          if(!this.nickname.length){
            this.tip = '请输入昵称'
            return false;
          }
          if (this.nickname.length < 3 || this.nickname.length > 32) {
            this.tip = '用户名为3~32位字符'
            return false;

          }
          return true;
        },
        //验证密码
        validatePassword() {
          if (this.password.length < 6 || this.password.length >18) {
            this.tip = '密码长度6到18位'
            return false;
          }

          if (this.password != this.repassword) {
            this.tip = '两次密码输入不一致'
            return false
          }
          return true
        },
        //验证 验证码
        validateCode() {
          if (!(this.code.length == 6)) {
            this.tip = '验证码长度错误'
            return false;
          }
          return true
        },
        //跳转到登录界面
        toLogin() {
          this.$router.push('/pc/home')
        },
        //切换密码可不可见
        visiblePass(type){
          this.$refs[type].type = this.$refs[type].type == 'password' ? 'text' : 'password';
          if (type == 'password') {
            this.type_password = this.type_password ? false : true;
          } else if(type == 'repassword'){
            this.type_repassword = this.type_repassword ? false : true;
          }
        }
      }
    }
</script>

<style lang="less" scoped>
  /* 注册*/
  .register-action{
    padding: 30px;
    font-family: Alibaba-PuHuiTi-R;
    .register-title{
      font-size: 24px;
      color: #222222;
      text-align: center;
      padding-bottom: 10px;
    }
    .input-wrap,.code-wrap{
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 7px 15px 7px 10px;
      background: #FFFFFF;
      border: 1px solid #E8E8E8;
      border-radius: 2px;
      margin-top: 20px;
      img{
        cursor: pointer;
        width: 24px;
        height: 24px;
      }
    }
    .input-wrap{
      input{
        width: 90%;
        font-size: 14px;
        color: #222222;
        padding: 5px 5px 5px 10px;
        border: none;
      }
      input::-webkit-input-placeholder{
        font-size: 15px;
        color: #CCCCCC;
      }
    }
    .code-wrap{
      border: none;
      padding: 0;
      input{
        width: 80%;
        padding: 5px;
      }
      .text-wrap{
        width: 60%;
        height: 100%;
        border: 1px solid #EEEEEE;
        border-radius: 2px;
        padding: 5px 10px;
        white-space: nowrap;
      }
    }
    .code-btn,.clock-btn{
      width: 40%;
      height: 42px;
      line-height: 42px;
      text-align: center;
      cursor: pointer;
      margin-left: 10px;
      color: #FFFFFF;
      border: 1px solid #E8E8E8;
    }
    .code-btn{
      background: #FF8622;
    }
    .clock-btn{
      background: #E1E1E1;
    }
  }
  ::-webkit-input-placeholder {
    font-family: Alibaba-PuHuiTi-R;
    font-size: 14px;
    color: #CCCCCC;
    letter-spacing: 0;
  }
  .go-register{
    cursor: pointer;
    color: #FFFFFF;
    margin-top: 40px;
    text-align: center;
    height: 48px;
    line-height: 48px;
    font-size: 18px;
    background: #FF8622;
  }
  /* 注册*/
</style>



// WEBPACK FOOTER //
// src/views/h5/register/Index.vue